module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_danone_01.6f362fd7.jpg";